module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/stopper-mobile-bg-856997e2b81420806b030469bb495240.webp";